'use strict';

module.exports = require('./es6/crc1').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc1.js
// module id = 638
// module chunks = 0